/**
 * Build batch-related paths when the coding tracker is mounted under a role prefix.
 * @param {string} root - '/admin' or '/faculty'
 * @param {string} batchId
 */
export function batchRootPath(root, batchId) {
  return `${root}/batch/${batchId}`;
}

export function batchAssignmentsPath(root, batchId) {
  return `${root}/batch/${batchId}/assignments`;
}

export function batchAssignmentPath(root, batchId, assignmentId) {
  return `${root}/batch/${batchId}/assignments/${assignmentId}`;
}

export function batchAssignmentProgressPath(root, batchId, assignmentId) {
  return `${root}/batch/${batchId}/assignments/${assignmentId}/progress`;
}

export function batchProgressPath(root, batchId) {
  return `${root}/batch/${batchId}/progress`;
}

export function batchStudentsPath(root, batchId) {
  return `${root}/batch/${batchId}/students`;
}
